import sanitizeHtml from 'sanitize-html';
import ArticleAuthorName from 'app/shared-components/article/ArticleAuthorName';
import ArticleAuthorAvatar from 'app/shared-components/article/ArticleAuthorAvatar';
import '../../../styles/quill-content.css';

export default function ArticleViewContent({ article, mode }) {
  if (!article) return null;
  
  const defaultImageUrl = `${window.location.origin}/assets/images/article/default_article_header.jpg`;

  return (
    <div>
      <div className="aspect-w-16 aspect-h-9 rounded-20 overflow-hidden">
        <img
          src={article.headerImageUrl || defaultImageUrl}
          alt={article.title}
          className="object-cover"
          onError={(e) => { e.target.src = defaultImageUrl; }}
        />
      </div>

      {(article.publishDate || article.createdAt) && (
        <div className="flex items-center gap-12 body-sm mt-40">
          <ArticleAuthorAvatar article={article} className="w-32 h-32" mode={mode} />
          <div>
            <ArticleAuthorName article={article} className="body-sm" /> {new Date(article.publishDate || article.createdAt).toLocaleString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
          </div>
        </div>
      )}

      <h1 className="h3 lg:h1 mt-12">
        {article.title}
      </h1>

      <div 
        className="mt-20 w-full max-w-full text-hs-black quill-content"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml((article.content || ''), {
          parser: { decodeEntities: false },
          allowedClasses: { '*': ['ql-*'] },
          allowedAttributes: {
            '*': ['data-list'],
            'a': ['href', 'target', 'rel']
          }
        }).replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ') }}
      />
    </div>
  )
}